var _Path, _G;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Path, Rect, Mask, G } from "react-native-svg";
var SvgFeedHides = function SvgFeedHides(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement(Path, {
    d: "M4 1a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v1H4V1Z",
    fill: "currentColor",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M2 3a1 1 0 0 1 1-1h18a1 1 0 0 1 1 1v1H2V3Z",
    fill: "currentColor",
    style: {
      opacity: 0.7
    }
  }), /*#__PURE__*/React.createElement(Rect, {
    x: 0.75,
    y: 4.75,
    width: 22.5,
    height: 22.5,
    rx: 1.25,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement(Rect, {
    x: 0.75,
    y: 4.75,
    width: 22.5,
    height: 22.5,
    rx: 1.25,
    style: {
      fill: "none"
    },
    stroke: "currentColor",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement(Mask, {
    id: "feed-hides_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 8,
    width: 16,
    height: 16
  }, _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#D9D9D9",
    d: "M4 8h16v16H4z"
  }))), _G || (_G = /*#__PURE__*/React.createElement(G, {
    mask: "url(#feed-hides_svg__a)"
  }, /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m14.515 16.649-.748-.749c.1-.552-.058-1.048-.473-1.489-.415-.44-.924-.61-1.527-.51l-.749-.75A2.298 2.298 0 0 1 12 12.95c.756 0 1.399.264 1.926.792.528.527.792 1.17.792 1.926 0 .188-.017.363-.05.525a2.013 2.013 0 0 1-.153.457Zm2.12 2.074-.735-.69a7.302 7.302 0 0 0 1.125-1.058c.328-.383.608-.82.842-1.308a6.553 6.553 0 0 0-2.392-2.675C14.436 12.33 13.278 12 12 12c-.322 0-.639.022-.95.067a6.41 6.41 0 0 0-.917.2l-.777-.777a6.725 6.725 0 0 1 1.292-.37c.439-.08.89-.12 1.352-.12 1.482 0 2.83.393 4.046 1.178a7.527 7.527 0 0 1 2.748 3.086.54.54 0 0 1 .06.183c.01.07.017.144.017.22a1.089 1.089 0 0 1-.077.402 7.171 7.171 0 0 1-.914 1.448 7.37 7.37 0 0 1-1.244 1.206Zm.188 3.505-2.346-2.325c-.342.126-.72.23-1.137.31-.415.08-.862.12-1.34.12-1.49 0-2.84-.392-4.05-1.178a7.594 7.594 0 0 1-2.744-3.086.538.538 0 0 1-.06-.182 1.41 1.41 0 0 1 0-.435.533.533 0 0 1 .06-.178c.25-.512.554-.986.91-1.421.357-.435.74-.822 1.15-1.16l-1.504-1.516a.477.477 0 0 1-.142-.343.482.482 0 0 1 .152-.36.478.478 0 0 1 .351-.144c.138 0 .255.048.351.145l11.052 11.05a.496.496 0 1 1-.703.703ZM7.97 13.395c-.352.28-.694.617-1.027 1.01a5.532 5.532 0 0 0-.809 1.262 6.554 6.554 0 0 0 2.392 2.675c1.039.66 2.197.991 3.475.991.303 0 .606-.025.906-.076.301-.052.556-.105.766-.16l-.844-.864a2.412 2.412 0 0 1-.828.151 2.622 2.622 0 0 1-1.926-.791 2.622 2.622 0 0 1-.64-2.755l-1.465-1.443Z",
    fill: "currentColor"
  }))));
};
export default SvgFeedHides;